export const version = '2.21.56';
//# sourceMappingURL=version.js.map